import { getLocale } from "../runtime";

const sv_czcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Czech Republic`
};

const czcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_czcountryenglish(inputs)
	return "czCountryEnglish";
};

export { czcountryenglish as "czCountryEnglish" };